import merge from 'lodash-es/merge';
import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  production: true,
  isPendo: true,
  isLocal: false,
  envName: 'dev',
  agGridLicenseKey: 'Using_this_{AG_Grid}_Enterprise_key_{AG-105959}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cloudmed}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{3}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_September_2027}____[v3]_[01]_MTgyMDk2MjgwMDAwMA==ce9e8e43b7cf588077928871879f59f3',
  auth0Config: {
    domain: 'auth.dev.cloudmed.com',
    clientId: '7jACJyMbgCpA0sXu8JPCmqEXd4aXt1kb',
    audience: 'dev.cloudmed',
    cmaiAudience: 'dev.cloudmed-ai.services',
    redirectUri: window.location.origin + '/callback',
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
  },
  api: {
    contractServiceBaseURL: 'https://cmedevpricingcontractapi.azurewebsites.net/api/',
    ruleEngineServiceBaseURL: 'https://cmedevruleruleengineapi.azurewebsites.net',
    globalServiceBaseURL: 'https://cmedevpricingglobalapi.azurewebsites.net/api/',
    sparkEngineServiceBaseURL: 'https://cmedevrulesparkengapi3.azurewebsites.net/api/',
    userManagementBaseUrl: 'https://cmedevwkdradminapi.azurewebsites.net',
    payerAccountabilityBaseUrl: 'https://cmedevwkdrpayeraccountabilityapi.azurewebsites.net/api',
    ruleManagementServiceBaseURL: 'https://cmedevrulemanagement.azurewebsites.net',
    identificationRuleEngineBaseURL: 'https://cmedevruleidentificationruleengineapi.azurewebsites.net',
    riUserManagementUrl: 'https://usermanagementapi.dev.cloudmed.com',
    dataApiUrl: 'https://riapi.dev.cloudmed.com',
    cmaiContractsPricingWorkflowApi: 'https://cmedevpricingworkflowapi.azurewebsites.net/api',
  },
  cloudMedApiBaseUrls: ['ruleEngineServiceBaseURL', 'userManagementBaseUrl', 'payerAccountabilityBaseUrl'],
  revenueIntelligenceBaseUrls: [
    'contractServiceBaseURL',
    'riUserManagementUrl',
    'globalServiceBaseURL',
    'sparkEngineServiceBaseURL',
    'ruleManagementServiceBaseURL',
    'identificationRuleEngineBaseURL',
    'dataApiUrl',
    'cmaiContractsPricingWorkflowApi',
  ],
  ui: {
    accountInfoURL: 'https://app.dev.cloudmed.com/account-info?id=',
    adminURL: 'https://admin.dev.cloudmed.com/',
    contractsURL: 'https://contracts.dev.cloudmed.com/',
  },
  sa: {
    filesURL: 'https://cmedevrulegensa.z20.web.core.windows.net/',
    execResultBaseURL: 'abfss://identificationengine@cmedevruledl.dfs.core.windows.net',
  },
  applicationId: 2,
  denialsApplicationId: 46,
  applicationName: 'Rules',
  denialsApplicationName: 'Denials',
  applicationGroupName: 'Rules',
  appInsights: {
    instrumentationKey: 'cb5f5e83-f14e-4aaa-85d0-493196b76a5d',
  },
  denialsEnabled: true,
};

export const environment = merge(commonEnv, env);
